import { createApi } from "@reduxjs/toolkit/query/react";
import { DynamicBaseQuery } from "./baseQuery";
import { CountriesIndexResponse } from "./types/residents/responses/CountriesIndexResponse";

export const countriesApi = createApi({
  reducerPath: "countriesApi",
  baseQuery: DynamicBaseQuery,
  tagTypes: ["Countries"],
  endpoints: (builder) => ({
    getCountries: builder.query<CountriesIndexResponse, undefined>({
      query: (params) => ({
        url: "/countries",
        method: "GET",
        params,
      }),
      keepUnusedDataFor: Infinity,
      providesTags: ["Countries"],
    }),
  }),
});

export const { useGetCountriesQuery, usePrefetch } = countriesApi;
